import EFPicture from 'elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function C() {
    const { useLang, Link } = useGlobal();
    const { t } = useLang('homebattery');
    return (
        <div id="C" className={`home-battery-C home-battery-box ${css['home-battery-C']}`}>
            <h2 className="title">{t('secC_title')}</h2>
            <div className="img-box">
                <EFPicture src="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718950031147/img02.jpg" alt={t('secC_title')} />
            </div>
            <p className="desc">{t('secC_desc1')}</p>
            <div className="img-box">
                <EFPicture src="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718950031355/img03.jpg" alt={t('secC_title')} />
            </div>
            <p className="desc">{t('secC_desc2')}</p>
            <Link
                className="link"
                href="https://blog.ecoflow.com/jp/household-use/"
                dataLayer={{
                    event: 'uaEvent',
                    event_name: 'select_news',
                    title_name: t('secC_title'),
                    button_name: t('secC_link'),
                }}
            >
                {t('secC_link')}
            </Link>
        </div>
    );
}
